<!-- src/views/pages/hrm/attendance/performance/review-table.vue -->
<template>
  <a-table
    class="table datatable thead-light"
    :columns="columns"
    :data-source="rows"
    :loading="loading"
    row-key="id"
    :row-selection="rowSelection"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'name'">
        <div class="d-flex align-items-center file-name-icon">
          <span class="avatar avatar-md avatar-rounded me-2">
            <img :src="avatar(record)" class="img-fluid" alt="img" />
          </span>
          <div>
            <h6 class="fw-medium">
              {{ fullName(record.employee?.user) || '-' }}
            </h6>
            <div class="text-muted small">
              {{ record.employee?.email || '-' }}
            </div>
          </div>
        </div>
      </template>

       <template v-else-if="column.key === 'dept'">
        {{
          record?.department?.name ||
          record?.employee?.department?.name ||
          "-"
        }}
      </template>

      <template v-else-if="column.key === 'designation'">
        {{
          record?.designation?.name ||
          record?.employee?.designation?.name ||
          "-"
        }}  

      </template>


      <template v-else-if="column.key === 'date'">
        {{ prettyDate(record.appraisal_date) }}
      </template>

      <template v-else-if="column.key === 'status'">
        <span class="badge d-inline-flex align-items-center badge-xs"
              :class="statusClass(record.status)">
          <i class="ti ti-point-filled me-1"></i>{{ record.status }}
        </span>
      </template>

      <template v-else-if="column.key === 'action'">
        <div class="action-icon d-inline-flex">
          <a href="javascript:void(0);" class="me-2" @click="$emit('edit', record)" v-can="'PerformanceAppraisal.Edit'">
            <i class="ti ti-edit"></i>
          </a>
          <a href="javascript:void(0);" @click="$emit('delete', record)" v-can="'PerformanceAppraisal.Delete'">
            <i class="ti ti-trash"></i>
          </a>
        </div>
      </template>
    </template>
  </a-table>
</template>

<script setup>
import { ref } from "vue";

const props = defineProps({
  rows: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
});
const emit = defineEmits(["edit","delete","bulk-delete"]);

const selectedRowKeys = ref([]);

const columns = [
  { title: "Name", dataIndex: "name", key: "name" },
  { title: "Designation", dataIndex: "designation", key: "designation" }, // optional if you have it on employee
  { title: "Department", dataIndex: "department", key: "dept" },      // shown under name too
  { title: "Appraisal Date", dataIndex: "appraisal_date", key: "date" },
  { title: "Status", dataIndex: "status", key: "status" },
  { title: "", dataIndex: "action", key: "action" },
];

const rowSelection = {
  selectedRowKeys: selectedRowKeys.value,
  onChange: (keys) => { selectedRowKeys.value = keys; },
  onSelect: () => {},
  onSelectAll: () => {},
};

function fullName(u) {
  if (!u) return "";
  return [u.first_name, u.last_name].filter(Boolean).join(" ");
}
function prettyDate(v) {
  if (!v) return "-";
  try { return new Date(v).toLocaleDateString(); } catch { return v; }
}
function statusClass(s) {
  const v = String(s||"").toLowerCase();
  return {
    "badge-success": v === "active",
    "badge-warning": v === "inactive",
  };
}
function avatar(record) {
  if (!record.employee?.avatar_url) return require("@/assets/img/users/user-01.jpg");
  return record.employee.avatar_url;
}

window.addEventListener("keydown", (e) => {
  if (e.key === "Delete" && selectedRowKeys.value.length) {
    emit("bulk-delete", selectedRowKeys.value);
  }
});
</script>
